import { array, object } from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const locationsValidationSchema = object().shape({
  locations: array(),
});
